import { CircleAlert, CircleCheck, Info } from "lucide-react"
import type { ComponentProps, ReactNode } from "react"
import {
  AlertAction,
  AlertDescription,
  AlertTitle,
  Alert as BaseAlert,
} from "../components/ui/alert"

export type Props = ComponentProps<typeof BaseAlert> & {
  action?: ReactNode
}

const ICONS_MAP = {
  info: <Info />,
  success: <CircleCheck />,
  warning: <CircleAlert />,
  error: <CircleAlert />,
} as const

export default function Alert({
  action,
  variant,
  title,
  children,
  ...props
}: Props) {
  return (
    <BaseAlert variant={variant} {...props}>
      {ICONS_MAP[variant ?? "info"]}
      {title && <AlertTitle>{title}</AlertTitle>}
      <AlertDescription>{children}</AlertDescription>
      {!!action && <AlertAction>{action}</AlertAction>}
    </BaseAlert>
  )
}
